import { Plural, Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconAnalysis from '@/icons/Analysis.svg';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import ClientStepper from '@/routes/Brand/Requests/Request/components/shared/ClientStepper';
import useViewPort from '@/utils/useViewport';

const Analysis = ({ request }: { request: RequestWithRelations }) => {
  const activeArticlesInAnalysisOrTransitWorkshopToWorkshop = request.articles.filter(
    (article) =>
      !article.cancelledAt &&
      (article.step?.step === 'analysis' ||
        (article.step?.step === 'transit' &&
          article.step.config.originType === 'workshop' &&
          article.step.config.destinationType === 'workshop'))
  );

  const { isMobile } = useViewPort();

  return (
    <BrandRequestMainContent>
      <Stack gap="1.5rem">
        <ClientStepper request={request} />
        <Stack row gap="0.5rem">
          <IconAnalysis className="color-tertiary-700" style={{ fontSize: '24px' }} />
          <Paragraph size={isMobile ? '100' : '50'}>
            <Trans id="store.request.analysis.text">
              The{' '}
              <Plural
                value={activeArticlesInAnalysisOrTransitWorkshopToWorkshop.length}
                one="item is"
                other="items are"
              />{' '}
              being analyzed by the workshop to see if the required actions correspond to{' '}
              <Plural
                value={activeArticlesInAnalysisOrTransitWorkshopToWorkshop.length}
                one="its"
                other="their"
              />{' '}
              needs.
            </Trans>
          </Paragraph>
        </Stack>
        <ClientArticlesList request={request} showPrice={!!request.client} showArticleComment />
      </Stack>
    </BrandRequestMainContent>
  );
};

export default Analysis;
